<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/specialEquipment/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">

        <el-form-item prop="deviceName" label="设备名称">
          <el-input clearable v-model="searchForm.deviceName" placeholder="请输入设备名称" />

        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select v-model="searchForm.status" clearable filterable placeholder="请选择状态">
            <el-option v-for="(item, index) of statusList" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="manager" label="管理人">
            <el-select v-model="searchForm.manager" clearable filterable placeholder="请选择管理人">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select>
          </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="设备名称" prop="deviceName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="安装位置" prop="location">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="状态" prop="status">
          <template v-slot="{ row }">

            <el-tag type="success" v-if="row.status == '1'">闲置</el-tag>
            <el-tag  v-if="row.status == '2'">运行</el-tag>
            <el-tag type="warning" v-if="row.status == '3'">维护</el-tag>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="设备代码" prop="deviceCode">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="管理人姓名" prop="managerName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建人姓名" prop="createUserName"></el-table-column>

        <el-table-column fixed="right" label="操作" width="160">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/specialEquipment/detail?deviceId=' + row.deviceId  )">详情</el-button>
              <el-button type="text"
              @click="$router.push('/specialEquipment/edit?deviceId=' + row.deviceId  )" v-if="hasEdit">编辑</el-button>

            <el-button v-if="hasDel" type="text" @click="deleteRow(row.deviceId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'specialEquipment',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        title: null,
        status: null,
        manager: null
      },
      // 空闲/工作中/外出
      statusList: [
        {
          label: '空闲',
          value: '1'
        },
        {
          label: '工作中',
          value: '2'
        },
        {
          label: '外出',
          value: '3'
        }

      ],
      userList: []

    }
  },
  computed: {

    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  watch: {
    '$route.query'(newV) {
      this.resetForm()
    }
  },
  created() {
    this.loadUser()
    this.loadData()
  },
  methods: {
    loadUser() {
      this.$axios.get(this.$apis.patrolProblemReport.selectIparkUserByRole, {
        userType: '1'
      }).then(res => {
        this.userList = res || []
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.specialEquipment.selectPaSpecialEquipmentByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        title: null,
        status: null
      }
      this.onSearch()
    },
    deleteRow(deviceId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.specialEquipment.deletePaSpecialEquipment, {
          deviceId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
